import React from 'react';
import c from 'classnames';
import { AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { useDialog } from '@uncinc/uncinc-react-kitchen-sink';

import Button from '../Button';
import DrawerMenuBackdrop from './Backdrop';
import DrawerMenuWrapper from './Wrapper';

import './style.scss';

// Subcomponents.
import Menu from './Menu';

interface Subcomponents {
  Menu: typeof Menu;
}

export interface DrawerMenuProps {
  dialogId?: string;
  className?: string;
  children: ((closeDialog: () => void) => React.ReactNode) | React.ReactNode;
}

const DrawerMenu: React.FC<DrawerMenuProps> & Subcomponents = (props) => {
  const {
    dialogId = 'DrawerMenu__dialog',
    className,
    children,
  } = props;

  const { t } = useTranslation();

  const classes = c('DrawerMenu', className);

  const {
    dialogIsOpen,
    openDialog,
    closeDialog,
    DialogComponent,
  } = useDialog();

  return (
    <>
      <Button
        type="secondary"
        icon="menu"
        iconPosition="left"
        onClick={() => openDialog()}
      >
        {t('buttons.menu')}
      </Button>

      <AnimatePresence>
        {(dialogIsOpen && (
          <DialogComponent
            id={dialogId}
            wrapperComponent={DrawerMenuWrapper}
            backdropComponent={DrawerMenuBackdrop}
          >
            <div className={classes}>
              <div className="DrawerMenu__header">
                <Button
                  type="secondary"
                  icon="clear"
                  iconPosition="left"
                  onClick={() => closeDialog()}
                >
                  {t('buttons.close')}
                </Button>
              </div>

              <div className="DrawerMenu__content">
                {typeof children === 'function' ? children(closeDialog) : children}
              </div>
            </div>
          </DialogComponent>
        ))}
      </AnimatePresence>
    </>
  );
};

DrawerMenu.Menu = Menu;

export default DrawerMenu;
